import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@awsui/components-react';

const VNCViewer = ({ vpId }) => {
  // noVNC is served by websockify in the container at /vnc/{vpId}/vnc.html
  // Traffic flows: browser → CloudFront → ALB → task:5901 (websockify)
  const cloudFrontDomain = window.location.hostname;
  const vncUrl = `https://${cloudFrontDomain}/vnc/${vpId}/vnc.html?autoconnect=true&resize=scale&reconnect=true`;

  return (
    <Box>
      <iframe
        src={vncUrl}
        title="VNC Viewer"
        style={{
          width: '100%',
          height: '600px',
          border: '1px solid #d1d5db',
          borderRadius: '4px',
        }}
        allow="clipboard-read; clipboard-write"
      />
    </Box>
  );
};

VNCViewer.propTypes = {
  vpId: PropTypes.string.isRequired,
};

export default VNCViewer;
